var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarYellowRatings = function SvgStarYellowRatings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3813 15.9961L16.7963 19.8666L15.0995 12.5659L20.7622 7.65688L13.2966 7.01576L10.3811 0.132812L7.4651 7.01576L0 7.65688L5.66272 12.5659L3.96518 19.8666L10.3813 15.9961Z",
    fill: "#FFB700"
  })));
};
export default SvgStarYellowRatings;